module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/76f05fc6c6d5bd694d13a4da81ee10bd.png";